import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const ProductCard = ({ product }) => {
  return (
    <Card className="bg-neutral-800/50 border-neutral-700/50 hover:border-amber-500/30 transition-all duration-300 overflow-hidden">
      <CardContent className="p-4">
        <div className="flex items-start space-x-4">
          
          {/* Ürün Görseli */}
          <div className="flex-shrink-0">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden border-2 border-neutral-700 shadow-lg">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Ürün Bilgileri */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <h3 className="text-white font-semibold text-base leading-snug">
                {product.name}
              </h3>

              <Badge className="bg-amber-500/20 text-amber-400 border-none text-sm font-bold whitespace-nowrap">
                {product.price} ₺
              </Badge>
            </div>

            {/* 🔴 AÇIKLAMA – ARTIK TAMAMI GÖRÜNÜR */}
            <p className="text-neutral-400 text-sm mt-1 whitespace-normal break-words leading-relaxed">
              {product.description}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
